<script setup lang="ts">
import type { BranchImages } from "~/types/directus-collections.d.ts";

defineProps<{
  image: BranchImages;
}>();

const aspect = ref<"portrait" | "landscape">("portrait");
const nuxtImg = ref();

function imageClass() {
  aspect.value =
    (nuxtImg.value.$el as HTMLImageElement).naturalWidth > (nuxtImg.value.$el as HTMLImageElement).naturalHeight ? "landscape" : "portrait";
}
</script>

<template>
  <div class="relative col-span-1 min-h-32 bg-tertiary xl:min-h-56" :class="aspect == 'portrait' ? 'row-span-2' : 'row-span-1'">
    <div v-if="image.image.description" class="absolute inset-x-2 bottom-2 max-w-fit rounded-md bg-primary p-2 text-white">
      {{ image.image.description }}
    </div>
    <CommonDirectusImage
      ref="nuxtImg"
      :img="image.image"
      :auth="image.is_public === false ? true : false"
      preset="gallery"
      class="size-full object-cover"
      @load="imageClass"
    >
    </CommonDirectusImage>
  </div>
</template>
